module.exports = __webpack_public_path__ + "img/thumbnail_AmericanBison_m_albino.714a0938.png";